import React from "react";
import PropTypes from "prop-types";
import { Button, Spinner } from "reactstrap";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import CustomInput from "@/shared/components/form/CustomInput";
import { useAddMutation, useUpdateMutation } from "@/services/pcApi";
import { APPLICATION_TYPE_TAG } from "@/shared/tagFile";
import { successToast } from "@/shared/components/toast";

const ApplicationTypeForm = ({ editData, setIsAddModalOpen }) => {
  const [addApplicationType, { isLoading: isApplicationTypeAddLoading }] =
    useAddMutation();
  const [updateApplicationType, { isLoading: isApplicationTypeUpdateLoading }] =
    useUpdateMutation();

  const applicationTypeValidationSchema = Yup.object().shape({
    Name: Yup.string().required("Please enter name."),
  });

  const onSubmit = (values) => {
    if (editData && Object.entries(editData).length > 0) {
      values.Id = editData.Id;
      updateApplicationType({
        entity: "CMSReference/ApplicationType",
        data: values,
        tag: APPLICATION_TYPE_TAG,
      }).then((response) => {
        if (!response.error) {
          !isApplicationTypeUpdateLoading && setIsAddModalOpen(false);
          successToast("Application-type updated successfully.");
        }
      });
    } else {
      addApplicationType({
        entity: "CMSReference/ApplicationType",
        data: values,
        tag: APPLICATION_TYPE_TAG,
      }).then((response) => {
        if (!response.error) {
          !isApplicationTypeAddLoading && setIsAddModalOpen(false);
          successToast("Application-type added successfully.");
        }
      });
    }
  };

  return (
    <Formik
      initialValues={{
        Name: editData && editData.Name ? editData.Name : "",
        Description:
          editData && editData.Description ? editData.Description : "",
      }}
      validationSchema={applicationTypeValidationSchema}
      onSubmit={onSubmit}
    >
      {(formik) => {
        const {
          errors,
          touched,
          values,
          handleSubmit,
          handleBlur,
          handleChange,
        } = formik;

        return (
          <Form>
            <CustomInput
              label="Name"
              name="Name"
              fieldErrors={errors.Name}
              fieldTouched={touched.Name}
              fieldValue={values.Name}
              handleBlur={handleBlur}
              handleChange={handleChange}
              required
            />
            <CustomInput
              label="Description"
              name="Description"
              type="textarea"
              fieldErrors={errors.Description}
              fieldTouched={touched.Description}
              fieldValue={values.Description}
              handleBlur={handleBlur}
              handleChange={handleChange}
            />
            <Button
              disabled={
                isApplicationTypeAddLoading || isApplicationTypeUpdateLoading
              }
              onClick={handleSubmit}
              className="modal_ok float-right"
              color="success"
            >
              {(isApplicationTypeAddLoading ||
                isApplicationTypeUpdateLoading) && (
                  <Spinner size="sm" variant="light" />
                )}{" "}
              Save
            </Button>
          </Form>
        );
      }}
    </Formik>
  );
};

ApplicationTypeForm.propTypes = {
  editData: PropTypes.object.isRequired,
  setIsAddModalOpen: PropTypes.func.isRequired,
};

export default ApplicationTypeForm;
